<div class="lottie" *ngIf="data">
    <div class="lottie-player">
        <lottie-player
            [attr.src]="lottieSrc"
            [attr.mode]="data.mode"
            [attr.direction]="data.direction"
            [attr.background]="data.background"
            [attr.speed]="data.speed"
            [attr.loop]="data.loop ? '' : null"
            [attr.controls]="data.controls ? '' : null"
            [attr.autoplay]="data.autoplay ? '' : null"
        ></lottie-player>
    </div>
</div>
